import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

interface StepProgressProps {
  progress: number;
}

export default styled.div<StepProgressProps>`
  height: 100%;
  width: ${({ progress }) => progress}%;
  max-width: 100%;
  max-height: 100%;
  background-color: #c7d522;
  transition: height 0.2s, width 0.2s;

  @media screen and (min-width: ${DESKTOP}px) {
    width: 100%;
    height: ${({ progress }) => progress}%;
  }
`;
